var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37316 0.874756H14.6976V21.1497C15.7456 21.1497 16.5796 21.1156 17.405 21.1558C22.7012 21.4126 28.0691 21.2353 33.2727 22.0746C38.9908 22.9961 43.5788 26.0555 45.1885 32.144C47.5388 41.0342 42.9299 48.1489 33.6335 50.0136C32.0068 50.3216 30.3546 50.474 28.6989 50.4686C21.179 50.5158 13.659 50.4564 6.13999 50.5201C4.66133 50.5324 4.19757 50.093 4.20193 48.5987C4.24997 33.2269 4.23079 17.8552 4.2369 2.48353C4.23952 2.01976 4.31289 1.56299 4.37316 0.874756ZM14.805 42.3347C19.5214 42.3347 24.0202 42.402 28.5173 42.3137C32.2082 42.2413 34.8564 39.9442 35.031 36.8935C35.3297 31.6767 33.6379 28.9185 29.3041 28.5246C24.9528 28.1289 20.5536 28.2285 16.1736 28.2102C15.7194 28.2102 14.8731 28.8652 14.8635 29.2312C14.7718 33.53 14.804 37.8324 14.804 42.3347H14.805Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4531 9.30899V0.520049H32.9347C32.9347 0.520049 43.9213 0.420479 45.2191 11.806C45.2191 11.806 45.4191 19.6962 40.7246 22.1924L33.1338 19.4954C33.1338 19.4954 37.6284 12.1047 30.2377 9.40857L18.4531 9.30899Z",
    fill: "#565ADD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.52002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbps);
export default __webpack_public_path__ + "static/media/bbps.07fc557b7adcef238c93f36d8c31c48a.svg";
export { ForwardRef as ReactComponent };